import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTABanner from './components/CTABanner';
import BlogSection from './components/BlogSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main>
        <HeroSection />
        <ServicesSection />
        <ProcessSection />
        <TestimonialsSection />
        <CTABanner />
        <BlogSection />
      </main>

      <Footer />

      {/* WhatsApp Floating Button */}
      <motion.a
        href="https://wa.me/905366460317"
        target="_blank"
        rel="nofollow noopener noreferrer"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: 'spring' }}
        className="fixed bottom-8 right-8 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center text-white shadow-2xl hover:scale-110 transition-transform duration-300 z-50 cursor-pointer"
        style={{ animation: 'pulse 2s infinite' }}
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </motion.a>

      <style>{`
        @keyframes pulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
          50% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0); }
        }
      `}</style>
    </div>
  );
};

export default HomePage;